<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Tin tức</h2>
        <el-button @click="createModel" size="small" type="info" class="btn-create">Thêm mới</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-filter">
        <el-col :span="4">
          <el-select v-model="filter.status" filterable clearable placeholder="Trạng thái" class="input-select" @change="changedBolgsStatus">
            <el-option
              v-for="item in lists.listStatus"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-select v-model="filter.category_blog_id" filterable clearable placeholder="Danh mục tin tức" class="input-select" @change="changeBlogsCategory">
            <el-option
              v-for="item in lists.listCategoryCourse"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-popover
            placement="bottom"
            title="Sắp xếp theo"
            width="400"
            trigger="click"
            content="Nội dung">
            <div class="model-filter-radio"
              v-for="(item, index) in sort"
              :key="index">
              <span>{{ item.groupName }}:</span>
              <el-radio
                v-for="(itemSort, index_itemSort) in item.groupFiled"
                :key="index_itemSort"
                v-model="filter.sort" :label="itemSort.label">{{ itemSort.text }}</el-radio>
            </div>
            <span class="model-filter-search" slot="reference">
              <i class="fas fa-sort"></i>
            </span>
          </el-popover>
        </el-col>
        <el-col :span="7"></el-col>
        <el-col :span="5">
          <el-input
            placeholder="Tìm kiếm ..."
            class="input-seach"
            clearable
            :prefix-icon="searching ? 'fas fa-spinner fa-spin' : 'el-icon-search'"
            v-model="filter.q">
          </el-input>
        </el-col>
      </div>
    </el-row>
    <el-row>
      <div class="model-pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="table.pagination.per_page"
            :pager-count="table.pagination.count"
            :current-page="table.pagination.current_page"
            :total="table.pagination.total"
            @current-change="changeCurrentPage">
          </el-pagination>
          <div>
            Hiển thị tới tin tức <strong>{{ table.meta_pagination }}</strong> / Tổng số: <strong>{{ table.pagination.total }}</strong> tin tức
          </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table
          v-loading="loading"
          border
          :data="table.database"
          style="width: 100%">
          <el-table-column
            label="#"
            type="index"
            width="40">
          </el-table-column>
          <el-table-column
            prop="image"
            width="200"
            align="center"
            label="Ảnh tin tức">
            <template slot-scope="scope">
              <img v-if="scope.row.image_path" :src="scope.row.image_path" class="course-image">
            </template>
          </el-table-column>
          <el-table-column
            label="Thông tin">
            <template slot-scope="scope">
              <div class="courses-info">
                <span style="color: green;font-weight: bold">{{ scope.row.name }}</span>
                <span>
                  Danh mục:
                  <span style="color: red">{{ scope.row.category_text }}</span>
                </span>
                <span>{{ scope.row.domain_name }}{{ scope.row.link_new }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="220"
            label="Tên miền">
            <template slot-scope="scope">
              <p style="font-weight: bold" v-if="scope.row.domain_name">{{ scope.row.domain_name }}</p>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            label="Trạng thái">
            <template slot-scope="scope">
              <div v-if="scope.row.status" class="item_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
              <div v-else class="item_not_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Kích hoạt"
            width="80"
            align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                @change="changeStatus(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            label="Nổi bật"
            width="80"
            align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.hot"
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                @change="changeHot(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            label="Nhóm"
            width="80"
            align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.group"
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                @change="changeGroup(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            label="Trang chủ"
            width="80"
            align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.home"
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                @change="changeHome(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            width="180"
            label="Hành động"
            header-align="center">
            <template slot-scope="scope">
              <div class="module-action">
                <el-tooltip effect="dark" content="Xem" placement="top">
                  <span @click="showModel(scope.row)">
                    <i class="fas fa-search icon-search"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Sửa" placement="top">
                  <span @click="updateModel(scope.row)">
                    <i class="far fa-edit icon-update"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Xóa" placement="top">
                  <span @click="confirmDeleteModel(scope.row)">
                    <i class="far fa-trash-alt icon-delete"></i>
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Blogs',
  metaInfo () {
    return {
      title: 'Tin tức'
    }
  },
  data () {
    return {
      loading: false,
      searching: false,
      filter: {
        q: '',
        status: '',
        category_blog_id: '',
        is_blog: 1,
        page: 1,
        limit: 15,
        sorted: '',
        include: ''
      },
      sort: [
        {
          groupName: 'Không sắp xếp',
          groupFiled: [
            { label: '', text: 'Không sắp xếp' }
          ]
        },
        {
          groupName: 'Tên tin tức',
          groupFiled: [
            { label: 'title:-1', text: 'Tăng dần' },
            { label: 'title:1', text: 'Giảm dần' }
          ]
        }
      ],
      lists: {
        listStatus: [
          {key: 1, value: 'Kích hoạt'},
          {key: 0, value: 'Chưa kích hoạt'}
        ],
        listCategoryCourse: [
          {key: 0, value: 'Chọn lĩnh vực'}
        ]
      },
      table: {
        database: [],
        meta_pagination: 0,
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        },
        timer: {}
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchDatabaseModel()
    this.fetchListCategoryCourse()
  },
  computed: {
    ...mapGetters('blogs', ['getSearchBlogsStatus', 'getSearchBlogsCategory'])
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    ...mapActions('blogs', ['changeSearchBlogsStatus', 'changeSearchBlogsCategory']),
    changedBolgsStatus (payload) {
      this.changeSearchBlogsStatus(payload)
    },
    changeBlogsCategory (payload) {
      this.changeSearchBlogsCategory(payload)
    },
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'blogs-index', text: 'Tin tức' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút tạo Model
    createModel () {
      this.$router.push({name: 'blogs-create'})
    },
    // Fetch dữ liệu
    fetchDatabaseModel () {
      this.loading = true

      this.filter.status = this.getSearchBlogsStatus
      this.filter.category_blog_id = this.getSearchBlogsCategory

      axios.get('blogs', {params: this.filter}).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về danh mục tin tức
    fetchListCategoryCourse () {
      axios.get('category-blogs', {params: {'status': 1, 'limit': -1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listCategoryCourse = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination () {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
    // Xem chi tiết
    showModel (model) {
      this.$router.push({name: 'blogs-show', params: {id: model.id}})
    },
    updateModel (model) {
      this.$router.push({name: 'blogs-update', params: {id: model.id}})
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeStatus (model) {
      let dataUpdate = {
        'status': model.status
      }
      axios.post('blogs/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeHot (model) {
      let dataUpdate = {
        'hot': model.hot
      }
      axios.post('blogs/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeGroup (model) {
      let dataUpdate = {
        'group': model.group
      }
      axios.post('blogs/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    changeHome (model) {
      let dataUpdate = {
        'home': model.home
      }
      axios.post('blogs/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // confirmDeleteModel
    confirmDeleteModel (model) {
      this.$confirm('Xác nhận xóa tin tức: ' + model.name, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel (model) {
      axios.delete('blogs/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal (model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    },
    // Thay đổi Current Page
    changeCurrentPage (currentPage) {
      this.filter.page = currentPage
      this.fetchDatabaseModel()
    }
  },
  watch: {
    'filter.status': function () {
      this.fetchDatabaseModel()
    },
    'filter.category_blog_id': function () {
      this.fetchDatabaseModel()
    },
    'filter.q': function () {
      this.searching = true
      clearTimeout(this.timer)
      let _this = this
      this.timer = setTimeout(function () {
        _this.searching = false
        _this.fetchDatabaseModel()
      }, 800)
    },
    'filter.sort': function () {
      this.fetchDatabaseModel()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-filter-search {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #efefef;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.model-filter-radio {
  margin-bottom: 10px;
}
.model-filter-radio span {
  margin-right: 20px;
  width: 135px;
  display: inline-block;
}
.course-image {
  width: 150px;
  border-radius: 2px;
}
.courses-info {
  display: flex;
  flex-direction: column;
}
.courses-info span {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/blogs/Index.vue